import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Settings/General'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings'

export const mediaPlatformSettingsRoute = createRoute({
  getParentRoute: () => mediaPlatformRoute,
  path: StaticRouteParameter.SETTINGS,
  loader: () => ({
    crumb: t('entity:publishing.settings'),
  }),
})

export const mediaPlatformSettingsLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsRoute,
  id: 'mediaPlatformSettingsLayout',
  component: Structure,
})

export const mediaPlatformSettingsOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsLayoutRoute,
  path: '/',
  component: Overview,
})
